import type { GuardJSON } from '@takeshape/schema';

export const GUARD_FORM_NAME = 'guardForm';

export const GUARD_HIDDEN_PROPERTY_NAMES = ['guardrailIdentifier', 'guardrailVersion'];

export const GUARD_POLICY_PROPERTY_NAMES: Array<keyof GuardJSON> = [
  'topicPolicyConfig',
  'contentPolicyConfig',
  'contextualGroundingPolicyConfig',
  'wordPolicyConfig',
  'sensitiveInformationPolicyConfig'
];
